// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","mediumDesktop":"(max-width: 1180px)","emailCaptureInput":"EmailCaptureInput_emailCaptureInput__P3ShO"};